// test943
(943 && 0);
